var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-taxation-project-form',{ref:"form",staticClass:"pt-taxation-project-form__withData",attrs:{"taxDetail":_vm.taxDetail,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }